// extracted by mini-css-extract-plugin
export var redoItem = "_ib-1";
export var redoTrigger = "_ib-0";